/* eslint-disable curly */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable no-underscore-dangle */
// Utility functions for date normalization and formatting

/**
 * Normalize various date representations (Firestore Timestamp, string, number, Date, etc.) to a JS Date object.
 * Returns undefined if value is not valid.
 */
export function normalizeDate(value: any): Date | undefined {
  function hasToDate(obj: any): obj is { toDate: () => Date } {
    return obj && typeof obj === 'object' && typeof obj.toDate === 'function';
  }
  if (!value) return undefined;
  if (hasToDate(value)) return value.toDate();
  if (value instanceof Date) return value;
  if (typeof value === 'string') return new Date(value);
  if (typeof value === 'number') {
    // If it's a 10-digit number, treat as seconds, otherwise milliseconds
    return value > 1e12 ? new Date(value) : new Date(value * 1000);
  }
  // Handle Firestore Timestamp object
  if (typeof value === 'object' && typeof value._seconds === 'number') {
    return new Date(value._seconds * 1000);
  }
  return undefined;
}

/**
 * Format a duration in seconds as mm:ss
 */
export function formatDuration(seconds?: number): string {
  if (!seconds) return 'N/A';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Format a timestamp in seconds as mm:ss
 */
export function formatTimestamp(seconds: number): string {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  if (hrs > 0) {
    return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

// Improved version for correct formatting
// Example: 1:02:05, 12:34, 0:05
export function formatTimestampReadable(seconds: number): string {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  if (hrs > 0) {
    return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  } else {
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
}
